import { __decorate, __metadata } from "tslib";
import { dispatchEvent, translate } from '@1inch-community/core/lit-utils';
import '@1inch-community/ui-components/button';
import { html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import '../../../../../shared-elements/token-icon';
import { tokenSelectButtonStyle } from './token-select-button.style';
let TokenSelectButtonElement = class TokenSelectButtonElement extends LitElement {
    static { this.tagName = 'inch-token-select-button'; }
    static { this.styles = tokenSelectButtonStyle; }
    render() {
        if (this.token) {
            return this.renderTokenSelectButton();
        }
        return this.renderEmptyTokenSelectButton();
    }
    renderTokenSelectButton() {
        return html `
      <button
        class="select-token-button"
        @click="${() => dispatchEvent(this, 'openTokenSelector', this.tokenType)}"
      >
        <inch-token-icon
          size="32"
          .symbol="${this.token.symbol}"
          .address="${this.token.address}"
          .chainId="${this.token.chainId}"
        ></inch-token-icon>
        <span class="symbol">${this.token.symbol}</span>
        <inch-icon class="icon" icon="chevronDown16"></inch-icon>
      </button>
    `;
    }
    renderEmptyTokenSelectButton() {
        return html `
      <inch-button
        type="secondary"
        size="l"
        @click="${() => dispatchEvent(this, 'openTokenSelector', this.tokenType)}"
      >
        <span class="select-token-text"
          >${translate('widgets.swap-form.swap-button.select-token')}</span
        >
        <inch-icon icon="chevronDown16"></inch-icon>
      </inch-button>
    `;
    }
};
__decorate([
    property({ type: Object, attribute: false }),
    __metadata("design:type", Object)
], TokenSelectButtonElement.prototype, "token", void 0);
__decorate([
    property({ type: String, attribute: true }),
    __metadata("design:type", String)
], TokenSelectButtonElement.prototype, "tokenType", void 0);
TokenSelectButtonElement = __decorate([
    customElement(TokenSelectButtonElement.tagName)
], TokenSelectButtonElement);
export { TokenSelectButtonElement };
//# sourceMappingURL=token-select-button.element.js.map